<template>
  <div v-if="mq('to-medium')" class="header-actions">
    <button
      class="header-actions__account"
      :aria-label="tStatic('search')"
      :aria-expanded="isSearchOpen ? 'true' : 'false'"
      aria-controls="header-bottom__search"
      @click="toggleSearch()">
      <oie-use-svg svg="header-search" class="header-actions__account-icon"></oie-use-svg>
    </button>

    <a
      v-if="mq('small')"
      href="/snabborder"
      class="button button--ghost button--icon-left header-bottom__fast-order-button"
      active-class="button--ghost-is-active">
      <oie-use-svg svg="fastlist"></oie-use-svg>
      <div class="header-bottom__fast-order-text">
        Snabborder
      </div>
    </a>

    <oie-the-header-cart css-classes="header-actions__cart"></oie-the-header-cart>

    <oie-the-header-burger
      v-if="mq('to-small')"
      :is-open="isNavigationOpen"
      css-classes="header-actions__navigation-toggler"
      data-pw="header-burger"
      @click.native="toggleNavigation()"></oie-the-header-burger>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import _ from 'lodash'

export default {
  computed: {
    ...mapGetters('ui', ['isNavigationOpen', 'isSearchOpen']),
    ...mapState('ui', ['shownMessages'])
  },
  watch: {
    shownMessages() {
      this.setNavigationHeight(true)
    }
  },
  mounted() {
    window.addEventListener('orientationchange', () => {
      this.setNavigationHeight(true)

      if (this.mq('medium') && this.isNavigationOpen) {
        this.toggleValue({ key: 'isNavigationOpen', data: false })
      }
    })

    window.addEventListener('resize', _.throttle(this.resizeNavigationHeight, 600))
  },
  methods: {
    ...mapActions('ui', ['toggleValue']),
    toggleSearch() {
      this.toggleValue({ key: 'isSearchOpen' })

      let headerSearch = null

      if (headerSearch === null) {
        headerSearch = document.querySelector('.header-bottom__search')
      }

      headerSearch.addEventListener('transitionend', () => {
        headerSearch.classList.toggle('header-bottom__search--remove-overflow')
      })

      if (this.isNavigationOpen) {
        this.toggleValue({ key: 'isNavigationOpen', data: false })
      }

      if(this.isSearchOpen) {
        setTimeout(() => {
          document.querySelector('.instant-search__input').focus()
        }, 100)
      }
    },
    toggleNavigation() {
      if (this.isSearchOpen) {
        this.toggleValue({ key: 'isSearchOpen', data: false })
      }

      this.setNavigationHeight()
      this.toggleValue({ key: 'isNavigationOpen' })

      const headerSearch = document.querySelector('.header-bottom__search')
      headerSearch.addEventListener('transitionend', () => {
        headerSearch.classList.remove('header-bottom__search--remove-overflow')
      })
    },
    setNavigationHeight(byPass) {
      if ((this.mq('to-medium') && !this.isNavigationOpen) || (this.mq('to-medium') && byPass)) {
        const headerArea = document.querySelector('.header-area-sticky')

        const vh = window.innerHeight * 0.01
        const navigationTopVh = (headerArea.offsetHeight * 0.01)

        document.documentElement.style.setProperty('--vh', `${vh}px`)
        document.documentElement.style.setProperty('--navigationTopVh', `${navigationTopVh}px`)
      }
    },
    resizeNavigationHeight() {
      this.setNavigationHeight(true)

      if (this.mq('medium') && this.isNavigationOpen) {
        this.toggleValue({ key: 'isNavigationOpen', data: false })
      }
    }
  }
}
</script>

<style lang="scss">
.header-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
}

.header-actions > *:not(:first-child) {
  margin-left: measure(half);

  @include media(small) {
    margin-left: measure(quarter);
  }
}

.header-actions__account {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.125rem;
  height: 2.125rem;
  margin: 0;
  padding: 0;
  border: none;
  background-color: transparent;
  overflow: hidden;
}

.header-actions__account-icon {
  width: 0.95625rem;
  height: 1.0625rem;
  color: color(text-inverted);
}

.header-actions .header-actions__cart {
  margin-left: measure(quarter);
}
</style>
